import { Component, Input } from '@angular/core';
import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TableItem } from '../documents-links/documents-links.component';

@Component({
  selector: 'lib-delete-doc-links',
  templateUrl: './delete-doc-links.component.html',
  styleUrls: ['./delete-doc-links.component.css']
})
export class DeleteDocLinksComponent {
  @Input() item!: TableItem;
  @Input() accountId!: string;

  constructor(public activeOffcanvas: NgbActiveOffcanvas) {}

  confirmDelete() {
    this.activeOffcanvas.close(true);
  }

  cancel() {
    this.activeOffcanvas.dismiss();
  }
}
